import { InboundOutboundType, ShipmentStatus } from '@shared/const'

import { Shipment } from '@shared-types/shipments'
import { Identifier, Nullable, Optional } from '@shared-types/util'

export type SideColumnType =
  | 'shipment_details'
  | 'create_slot'
  | 'book_shipment'
  | 'edit_slot'
  | 'checklist_details'
  | 'create_checklist'
  | 'voucher_details'
  | 'check_in_shipment'
  | 'visit_details'
  | 'extraction_run_details'

export type SelectedShipmentWithStatus = {
  nid: string
  shipment_status: ShipmentStatus
}
export type ShipmentDetailsTabKey = 'summary' | 'details' | 'content'

export type ShipmentDetailsSideBarState = {
  type: 'shipment_details'
  selectedShipmentNid: Optional<string>
  activeTabKey: ShipmentDetailsTabKey
}

export type CreateSlotSideBarState = {
  type: 'create_slot'
  facilityId: Identifier
}

export enum BookShipmentStep {
  CREATE_SINGLE_SENDER_SHIPMENT = 0,
  CREATE_MULTI_SENDER_SHIPMENT = 1,
  SELECT_SLOT = 2,
}

export type BookShipmentSideBarState = {
  type: 'book_shipment'
  selectedShipmentNid?: string
  selectedSlotId?: Nullable<Identifier>
  selectedPOId?: Nullable<Identifier>
  showCreateShipmentForm?: boolean
  currentStep: BookShipmentStep
}

export type EditSlotSideBarState = {
  type: 'edit_slot'
  facilityId: Identifier
  selectedSlotId: Identifier
  shipmentType: InboundOutboundType
}

export type CreateVoucherState = {
  type: 'create_voucher'
}

export type ChecklistDetailsState = {
  type: 'checklist_details'
  selectedChecklistId: Identifier
  facilityId: string
  selectedNid: string
}

export type CreateChecklistState = {
  type: 'create_checklist'
  facilityId: string
}

export type VoucherDetailsState = {
  type: 'voucher_details'
  selectedVoucherId: Identifier
}

export enum CheckInShipmentStep {
  INITIAL = 0,
  SHIPMENT_DETAILS = 1,
  TRANSPORT_DETAILS = 2,
  ENTRANCE_CONTROLS = 4,
}

export type CheckInShipment = Pick<
  Shipment,
  '_id' | 'nid' | 'department' | 'type' | 'supplier_companies_ids'
>
export type CheckInShipmentWithKey = CheckInShipment & { key: number }
export type CheckInShipmentState = {
  type: 'check_in_shipment'
  selectedShipment?: SelectedShipmentWithStatus
  currentStep: CheckInShipmentStep
}

export type VisitDetailsState = {
  type: 'visit_details'
  selectedVisitId: Identifier
}

export type ExtractionRunDetailsState = {
  type: 'extraction_run_details'
  selectedRunId: Identifier
}
